import { authPost } from "@api";

export const createTokenRequest = (
  deploymentId: string,
  claimKey: string
): Promise<{}> => {
  const path = `/api/agent/deployments/${deploymentId}/tokens/requests`;
  const body = { token_request_key: claimKey };
  return authPost<{ token_request_key: string }, {}>(path, body);
};
